export const numberFormatter = (value) => {
  if (value === undefined || value === null || value === '') return '';
  const [whole, decimal] = String(value).split('.');
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return decimal !== undefined ? `${formattedWhole},${decimal}` : formattedWhole;
};

export const numberParser = (value) => {
  if (!value) return 0;
  const normalized = String(value).replace(/\./g, '').replace(/,/g, '.').replace(/[^\d.-]/g, '');
  const parsed = Number(normalized);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export const moneyInputProps = {
  formatter: numberFormatter,
  parser: numberParser,
};
